import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getElementControls,
  getElementTypeFilterOptions,
} from "core-integration/src/store/elements/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { getTeams } from "core-integration/src/store/teams/reducers";
import { FieldWrap, SelectField } from "../FieldRenderers";

type Props = WithTranslation & {
  handleFilterChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const ElementFilter = ({ handleFilterChange, t }: Props) => {
  const controls = useSelector(getElementControls);
  const elementTypeFilterOptions = useSelector(getElementTypeFilterOptions);
  const player = useSelector(getPlayerData);
  const teams = useSelector(getTeams);

  // Eliteserien
  const eliteserien = teams
    .filter((team: any) => team.unavailable === false)
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <FieldWrap>
      <SelectField
        id="filter"
        name="filter"
        label={t("view", "View")}
        value={controls.filter}
        onChange={handleFilterChange}
        required={false}
      >
        <optgroup label="Global">
          <option value="all" aria-selected={controls.filter === "all"}>
            {t("allPlayers", "All players")}
          </option>
          {player && player.entry && (
            <option value="wl" aria-selected={controls.filter === "wl"}>
              {t("watchList", "Watchlist")}
            </option>
          )}
        </optgroup>
        <optgroup label={t<string>("byPosition", "By position")}>
          {elementTypeFilterOptions.map((o) => (
            <option
              key={o.value}
              value={o.value}
              aria-selected={controls.filter === o.value}
            >
              {o.label}
            </option>
          ))}
        </optgroup>
        <optgroup label={t<string>("topLeague", "Eliteserien")}>
          {eliteserien.map((o) => (
            <option
              key={`te_${o.id}`}
              value={`te_${o.id}`}
              aria-selected={controls.filter === `te_${o.id}`}
            >
              {o.name}
            </option>
          ))}
        </optgroup>
      </SelectField>
    </FieldWrap>
  );
};

export default withTranslation()(ElementFilter);
